import { type FC, type ReactNode } from 'react';

import { childrenChangesBlock, childrenSubtree } from '../styles';

interface Props {
	children: ReactNode;
	setShowChildren: (_) => void;
}

const ChildrenChangesWrapper: FC<Props> = (props) => {
	const { children, setShowChildren } = props;

	return (
		<div className={childrenChangesBlock}>
			<div className={childrenSubtree} onClick={() => setShowChildren(false)} />
			{children}
		</div>
	);
};

export default ChildrenChangesWrapper;
